import { render } from "./Changelogs.vue?vue&type=template&id=06d3ccb0&scoped=true&lang=pug"
import script from "./Changelogs.vue?vue&type=script&lang=js"
export * from "./Changelogs.vue?vue&type=script&lang=js"

import "./Changelogs.vue?vue&type=style&index=0&id=06d3ccb0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d3ccb0"]])

export default __exports__